import { atom } from "jotai";
import { Node, Edge } from "@xyflow/react"; // Assuming these types are needed
import { programmaticNavigationExpectedAtom } from "../index"; // Import the flag atom

// Define types for input
interface CreateCanvasInput {
  nodes: Node[];
  edges: Edge[];
  options?: {
    skipBeforeUnloadCheck?: boolean;
  };
}

export const createNewCanvasSetter = atom(
  null,
  async (_, set, canvasData: CreateCanvasInput) => {
    const { nodes, edges } = canvasData;
    try {
      // Send POST request to create new canvas
      const res = await fetch(`/api/canvas/v2/canvases/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        // Only send nodes/edges to the API
        body: JSON.stringify({ nodes, edges }),
      });

      if (!res.ok) {
        throw new Error("Failed to create new canvas");
      }

      const json = await res.json();
      const canvasId = json.id;

      // Always set the flag before navigating
      set(programmaticNavigationExpectedAtom, true);

      window.location.href = `/app/canvas/${canvasId}`;
      // Note: Resetting the flag after this line might not execute if navigation is immediate.
      // The beforeunload handler is responsible for resetting it upon successful navigation.
    } catch {
      // Reset the flag ONLY on error, as beforeunload handles the success case
      set(programmaticNavigationExpectedAtom, false);
    }
  },
);

createNewCanvasSetter.debugLabel = "createNewCanvasSetter";
